import { ComponentType, FunctionComponent } from 'react';
import { useFeatureFlagForConsumer } from 'featureFlags/useConsumerFeatureFlag';
import CmsLegalPage, { TockLegalPageType } from 'routes/legal/CmsLegalPage';

export interface FeatureGatedLegalPageProps {
  /** Static, code-shipped V1 route rendered when the CMS flag is off. */
  v1: ComponentType;
  /** CMS page type rendered via {@link CmsLegalPage} when `CMS_LEGAL_PAGES` is on. */
  pageType: TockLegalPageType;
}

/**
 * Chooses between a legal page's static V1 route and its CMS-driven V2 render
 * ({@link CmsLegalPage}, which also emits the page's `<head>` metadata) based on
 * the single all-or-nothing `CMS_LEGAL_PAGES` flag. All seven legal routes share
 * this one flag; there is intentionally no per-type `flagName` prop (see JCE-7273).
 */
const FeatureGatedLegalPage: FunctionComponent<FeatureGatedLegalPageProps> = ({
  v1: V1,
  pageType,
}) => {
  const cmsLegalPagesEnabled = useFeatureFlagForConsumer('CMS_LEGAL_PAGES');

  return cmsLegalPagesEnabled ? <CmsLegalPage pageType={pageType} /> : <V1 />;
};

export default FeatureGatedLegalPage;
